// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__rEz8E","title":"App_title__3KC7T"};